import { React, useState, useEffect } from 'react';

const EscrowAccount = ({  setTransectionData, transectionData }) => {

    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            return updatedData;
        });
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Account Code</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Account Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">IBAN</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Swift Code</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Contact no</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Address</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EscrowAccount